
































































































import { AssetEnum, AssetRepository } from "@/lib/AssetRepository";
import { IThgStatus } from "@/lib/interfaces/thg/thg-status.interface";
import { PartnerColor } from "@/lib/partnerColor";
import { thgStatusMap } from "@/lib/utility/thgStatusMap";
import { ThgChargingStationViewModelGen, ThgThgMeterReadingViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";

@Component({
  components: {
    Debug
  }
})
export default class ThgChargingStationCard extends Vue {
  @Prop()
  selection!: ThgChargingStationViewModelGen;

  @Prop()
  meterReadings!: ThgThgMeterReadingViewModelGen[];

  @Prop()
  loading!: boolean;

  partnerColor = new PartnerColor();
  thgStatusMap = thgStatusMap;

  get charging() {
    return AssetRepository.getAsset(this.$vuetify.theme.dark, AssetEnum.charging);
  }

  get dateOptions() {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric"
    };
    return options;
  }

  get commissioningDate() {
    return this.toDate(this.selection.commissioningDate);
  }

  addMeterReading() {
    this.$router.push({ path: `/charging-station/${this.selection.id}/meter-reading` });
  }

  toDate(date: string) {
    return new Date(date).toLocaleString("de-DE", this.dateOptions as any);
  }

  thgStatus(thgStatusEnum: any): IThgStatus {
    return (
      this.thgStatusMap.get(thgStatusEnum) || {
        text: "components.thg.ThgStatusMap.UNDEFINED.text",
        icon: "mdi-help",
        portalText: "components.thg.ThgStatusMap.UNDEFINED.portalText",
        color: "error"
      }
    );
  }

  goToChargingStation(item: ThgChargingStationViewModelGen) {
    this.$router.push({ path: `/charging-station/${item.id}` });
  }
}
